/* ============================================================
   Collage Builder — Countdown Timer Custom Element
   ============================================================ */

if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.endDate = new Date(this.dataset.endDate).getTime();
      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');
      this.expiredEl = this.querySelector('[data-expired]');
      this.timerEl = this.querySelector('[data-timer]');
      this.interval = null;
    }

    connectedCallback() {
      if (isNaN(this.endDate)) return;

      // Respect prefers-reduced-motion — still show countdown, just don't animate
      this.update();
      this.interval = setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    update() {
      const now = Date.now();
      const diff = this.endDate - now;

      if (diff <= 0) {
        this.showExpired();
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
      if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
      if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
      if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    showExpired() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }

      if (this.timerEl) this.timerEl.style.display = 'none';
      if (this.expiredEl) this.expiredEl.style.display = 'block';
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
